const regionNames: Record<string, string> = {
  AE: "United Arab Emirates",
  AR: "Argentina",
  ASIA: "Asia",
  AT: "Austria",
  AU: "Australia",
  BD: "Bangladesh",
  BE: "Belgium",
  BH: "Bahrain",
  BR: "Brazil",
  CA: "Canada",
  CN: "China",
  CO: "Colombia",
  CZ: "Czechia",
  DE: "Germany",
  EU: "Europe",
  EUROPE: "Europe",
  FI: "Finland",
  FR: "France",
  GB: "United Kingdom",
  GLOBAL: "Global",
  HK: "Hong Kong",
  HU: "Hungary",
  ID: "Indonesia",
  IN: "India",
  IT: "Italy",
  JP: "Japan",
  KH: "Cambodia",
  KW: "Kuwait",
  LATAM: "Latin America",
  LB: "Lebanon",
  MENA: "Middle East & North Africa",
  MX: "Mexico",
  MY: "Malaysia",
  NA: "North America",
  OM: "Oman",
  PH: "Philippines",
  PL: "Poland",
  QA: "Qatar",
  RO: "Romania",
  RU: "Russia",
  SA: "Saudi Arabia",
  SEA: "Southeast Asia",
  SG: "Singapore",
  SK: "Slovakia",
  TH: "Thailand",
  TR: "Türkiye",
  TW: "Taiwan",
  US: "United States",
  VN: "Vietnam",
  ZA: "South Africa",
};

export const getRegionDisplayName = (code?: string, fallback?: string) => {
  const normalized = String(code || "")
    .trim()
    .toUpperCase();
  if (!normalized) return fallback || "Global";
  if (normalized.includes("/")) {
    return normalized
      .split("/")
      .map((part) => regionNames[part] || part)
      .join(" / ");
  }
  return regionNames[normalized] || fallback || normalized;
};

export const isSingaporeRegion = (
  region?: {
    code?: string;
    slug?: string;
    name?: string;
  } | null,
) => {
  if (!region) return false;
  const code = (region.code || "").toUpperCase();
  const slug = (region.slug || "").toLowerCase();
  const name = (region.name || "").toLowerCase();

  // Exclude Cambodia explicitly
  if (
    code === "KH" ||
    code.startsWith("KH") ||
    code.includes("KH") ||
    slug.includes("cambodia") ||
    name.includes("cambodia")
  ) {
    return false;
  }

  return (
    code === "SG" ||
    code === "MY/SG" ||
    code === "SG/MY" ||
    code === "SG/MY/LK" ||
    slug === "singapore" ||
    slug === "my-sg" ||
    slug === "sg-my" ||
    name.includes("singapore")
  );
};

